import camelcaseKeys from "camelcase-keys";

export function toCamel(
	o: Record<string, unknown> | ReadonlyArray<Record<string, unknown>>,
) {
	return camelcaseKeys(o, {
		deep: true,
	});
}
